/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Checkbox, Input } from 'antd';

import Swal from 'sweetalert2';

import { toast } from 'react-toastify';

import api from '~/services/api';

import { ContainerAlerta } from './styles';

import iconAlertConfirm from '~/assets/icons/iconAlertConfirm.svg';

import history from '~/services/history';

import { store } from '~/store';

export default function AlertaReenviarLinhaDeCuidado({
  setConfirmaReenvio,
  reenvioConfirmado,
  setReenvioConfirmado,
  confirmaReenvioCheck,
  setConfirmaReenvioCheck,
  handleCancel,
  senha,
  setSenha,
  periodoSelecionado,
  linhaDeCuidadoValue,
}) {
  const [resquestPass, setRequestPass] = useState(false);

  function onChange(e) {
    setConfirmaReenvioCheck(e.target.checked);
  }

  function confirmaReenvio() {
    if (!confirmaReenvioCheck) {
      toast.warn('Você precisa confirmar o "checkbox" para continuar.', {
        autoClose: 7000,
      });

      return;
    }
    setReenvioConfirmado(true);
  }

  async function confirmPasswordRequest() {
    try {
      setRequestPass(true);
      const response = await api.post('autenticacao/autenticar', {
        cpf: sessionStorage.getItem('cpf'),
        password: senha,
      });

      if (String(response?.status).substr(0, 2) === '20') {
        setConfirmaReenvio(true);
      }
      setRequestPass(false);
    } catch (error) {
      setRequestPass(false);
      Swal.fire({
        title: 'Atenção',
        html: `<p>Senha inválida.</p>`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      }).then(() => {
        window.location.reload();
      });
    }
  }

  function confirmaSenha() {
    if (!senha) {
      toast.warn('Digite sua senha para continuar.', {
        autoClose: 7000,
      });

      return;
    }

    confirmPasswordRequest();
  }

  return (
    <>
      {reenvioConfirmado ? (
        <ContainerAlerta>
          <img src={iconAlertConfirm} alt="Confirma reenvio" />
          <h3 style={{ color: '#282828' }}>
            Para prosseguir com{' '}
            <span style={{ color: '#cc0000' }}>
              a exclusão dos dados da competência {periodoSelecionado}
            </span>{' '}
            e reenviar todas as informações,{' '}
            <span style={{ textDecoration: 'underline' }}>
              digite a sua senha no campo abaixo:
            </span>
          </h3>

          <div className="confirmInputSenha">
            <Input.Password
              placeholder="Digite sua senha"
              onChange={e => setSenha(e.target.value)}
            />
          </div>

          <div className="buttonActions">
            <button type="button" onClick={confirmaSenha}>
              {resquestPass ? 'Validando senha...' : 'Prosseguir'}
            </button>
            <button
              type="button"
              className="buttonCancel"
              onClick={handleCancel}
            >
              Cancelar
            </button>
          </div>
        </ContainerAlerta>
      ) : (
        <ContainerAlerta confirmaReenvioCheck={confirmaReenvioCheck}>
          <img src={iconAlertConfirm} alt="Confirma reenvio" />
          <h2>ATENÇÃO!!!</h2>
          <h3>
            Já existem dados submetidos para essa competência.
            Para um novo envio, todos os dados anteriores serão excluídos.
            Deseja prosseguir?
          </h3>
          <p>
            Certifique-se de que todos os registros, incluindo os inseridos
            manualmente (direto no sistema), estão no novo arquivo a ser
            submetido.
          </p>

          <div className="confirmAction">
            <Checkbox onChange={onChange}>
              Desejo deletar os dados registrados nessa competência e fazer um
              novo envio.
            </Checkbox>
          </div>

          <div className="buttonActions">
            <button type="button" onClick={confirmaReenvio}>
              Prosseguir
            </button>
            <button
              className="buttonCancel"
              type="button"
              onClick={handleCancel}
            >
              Cancelar
            </button>
          </div>
        </ContainerAlerta>
      )}
    </>
  );
}
